import { SYSTEM_ACTIONS, SetMobileAction, SYSTEM_ACTION_TYPES } from "../actions/system"
import { Action } from "redux-first-router"

export type SystemState = {
  theme: "dark" | "light" | "paper",
  isMobile: boolean,
  mobileMenuOpen: boolean,
  messageClientStatus: "Active" | "Inactive" | "Reconnecting",
  alertsVisibility: ALERTS_VISIBILITY,
  oauthNonce: string | undefined,
  deferredDestination?: Action,
  agreedUponTosVersion: string,
  filterMenuOpen: boolean,
  deviceId?: string,
  appIsActive: boolean,
  appKeyboardIsOpen: boolean,
  appKeyboardHeight: number,
  windowDims: {
    w: number,
    h: number
  }
}

export enum ALERTS_VISIBILITY {
  ALL = "ALL",
  CHANNEL = "CHANNEL"
}

export const initialState: SystemState = {
  // theme: (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light',
  theme: 'paper',
  isMobile: true,
  mobileMenuOpen: true,
  messageClientStatus: "Inactive",
  alertsVisibility: ALERTS_VISIBILITY.ALL,
  oauthNonce: undefined,
  agreedUponTosVersion: "",
  filterMenuOpen: false,
  appIsActive: true,
  appKeyboardIsOpen: false,
  appKeyboardHeight: 0,
  windowDims: {
    w: 0,
    h: 0
  }
}

export default (state = initialState, action: SYSTEM_ACTION_TYPES): SystemState => {
  switch (action.type) {
    case SYSTEM_ACTIONS.THEME_TOGGLED:
      return {
        ...state,
        theme: state.theme === 'dark' ? 'light' : 'dark'
      }
    case SYSTEM_ACTIONS.THEME_SET:
      return {
        ...state,
        theme: action.payload!
      }
    case SYSTEM_ACTIONS.MOBILE_SET:
      return {
        ...state,
        isMobile: (action as SetMobileAction).payload
      }
    case SYSTEM_ACTIONS.MOBILE_MENU_OPENED:
      return {
        ...state,
        mobileMenuOpen: true,
      }
    case SYSTEM_ACTIONS.MOBILE_MENU_CLOSED:
      return {
        ...state,
        mobileMenuOpen: false,
      }
    case SYSTEM_ACTIONS.MESSAGE_CLIENT_STATUS_SET:
      return {
        ...state,
        messageClientStatus: action.payload,
      }
    case SYSTEM_ACTIONS.ALERTS_VISIBILITY_SET:
      return {
        ...state,
        alertsVisibility: action.payload,
      }
    case SYSTEM_ACTIONS.OAUTH_NONCE_SET:
      return {
        ...state,
        oauthNonce: action.payload
      }
    case SYSTEM_ACTIONS.DEFERRED_DESTINATION_SET:
      return {
        ...state,
        deferredDestination: action.payload
      }
    case SYSTEM_ACTIONS.DEFERRED_DESTINATION_CLEARED:
      return {
        ...state,
        deferredDestination: undefined
      }
    case SYSTEM_ACTIONS.TERMS_ACCEPTED:
      return {
        ...state,
        agreedUponTosVersion: action.payload
      }
    case SYSTEM_ACTIONS.FILTER_MENU_OPENED:
      return {
        ...state,
        filterMenuOpen: true,
      }
    case SYSTEM_ACTIONS.FILTER_MENU_CLOSED:
      return {
        ...state,
        filterMenuOpen: false,
      }
    case SYSTEM_ACTIONS.DEVICE_ID_SET:
      return {
        ...state,
        deviceId: action.payload,
      }
    case SYSTEM_ACTIONS.APP_STATE_ACTIVATED:
      return {
        ...state,
        appIsActive: true,
      }
    case SYSTEM_ACTIONS.APP_STATE_DEACTIVATED:
      return {
        ...state,
        appIsActive: false,
      }
    case SYSTEM_ACTIONS.APP_KEYBOARD_OPENED:
      return {
        ...state,
        appKeyboardIsOpen: true,
        appKeyboardHeight: action.payload??0
      }
    case SYSTEM_ACTIONS.APP_KEYBOARD_CLOSED:
      return {
        ...state,
        appKeyboardIsOpen: false,
        appKeyboardHeight: 0
      }
    case SYSTEM_ACTIONS.WINDOW_DIMENSIONS_CHANGED:
      return {
        ...state,
        windowDims: action.payload
      }
    default:
      return state
  }
}